import * as Counter from './App/Counter';
import * as UnifyHeights from './App/UnifyHeights';
import * as PageScroll from './App/PageScroll';
import * as ContactFilter from './App/ContactFilter';
import * as InfinityScroller from './App/InfinityScroller';
import * as OffCanvas from './App/OffCanvas';
import * as AnimatedBarGraphs from './App/AnimatedBarGraphs';
import * as FollowToMenu from './App/FollowToMenu';
import * as OrderCalculation from './App/OrderCalculation';
import * as GoogleReCaptcha from './Spinao/GoogleReCaptcha';
import * as NetteAjaxForm from './Spinao/NetteAjaxForm';
import * as OverlayDialog from './Spinao/OverlayDialog';
import './Spinao/CookieConsent';

$(document).ready(function () {
    Counter.initialize();
    UnifyHeights.initialize('.product-content');
    UnifyHeights.initialize('.reference-block');
    UnifyHeights.initialize('.feature-production-content');
    UnifyHeights.initialize('.feature-production-title');
    UnifyHeights.initialize('.feature-content');
    UnifyHeights.initialize('.feature-content2');
    UnifyHeights.initialize('.pro-content-a');
    UnifyHeights.initialize('.pro-content-b');
    PageScroll.initialize();
    ContactFilter.initialize();
    InfinityScroller.initialize();
    OffCanvas.initialize();
    AnimatedBarGraphs.initialize();
    FollowToMenu.initialize();
    NetteAjaxForm.initialize('[data-ajax="form"]');
    GoogleReCaptcha.initialize();
    OverlayDialog.initialize();
    OrderCalculation.initialize();
});

